import {
    FormFieldWithOptions,
    FormFieldWithOptionsConfig,
} from './formFieldWithOptions';

export class CheckboxesField<TOptionKey> extends FormFieldWithOptions<
    TOptionKey[],
    TOptionKey
> {
    constructor(config: FormFieldWithOptionsConfig<TOptionKey[], TOptionKey>) {
        super(config);

        this.valueIsArrayType = true;
    }
}
